"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormSelect = exports.formatDefaultValues = exports.getFormattedValue = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactUforms = require("react-uforms");

var _ = require("../../../");

var _select = require("./select.styled");

var _selectElements = require("./select-elements");

var _triangleDown = _interopRequireDefault(require("../../../icons/triangle-down"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getFormattedValue = function getFormattedValue(inputValue, options) {
  var index = options.findIndex(function (option) {
    return option.value === inputValue;
  });
  return index !== -1 ? options[index] : {
    label: inputValue,
    value: inputValue
  };
};

exports.getFormattedValue = getFormattedValue;

var formatDefaultValues = function formatDefaultValues(inputValue, options) {
  if (Array.isArray(inputValue)) {
    return inputValue.map(function (item) {
      return getFormattedValue(item, options);
    });
  }

  return getFormattedValue(inputValue, options);
};

exports.formatDefaultValues = formatDefaultValues;

var FormSelect = function FormSelect(props) {
  var id = props.id,
      name = props.name,
      disabled = props.disabled,
      required = props.required,
      options = props.options,
      isMulti = props.isMulti,
      isClearable = props.isClearable,
      instanceId = props.instanceId,
      onInputChange = props.onInputChange,
      _onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      location = props.location,
      _onBlur = props.onBlur,
      isMobile = props.isMobile,
      size = props.size,
      hideError = props.hideError,
      menuPlacement = props.menuPlacement,
      initColorMark = props.colorMark,
      isSearchable = props.isSearchable,
      showMultiOptionsCount = props.showMultiOptionsCount,
      dataTest = props['data-test'],
      dataTestId = props['data-test-id'];

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var colorMark = initColorMark && (initColorMark.includes('#') ? initColorMark : "#".concat(initColorMark));
  var Option = location && _selectElements.OptionLocation || isMulti && _selectElements.OptionMultiple || _selectElements.OptionBasic;

  var mobileOptions = function mobileOptions(newOptions) {
    var optionsWithPlaceholder = placeholder ? [{
      label: placeholder,
      name: placeholder,
      value: null,
      hidden: true
    }].concat(_toConsumableArray(newOptions)) : newOptions;

    if (Array.isArray(optionsWithPlaceholder)) {
      return optionsWithPlaceholder.map(function (_ref) {
        var name = _ref.label,
            value = _ref.value,
            disabled = _ref.disabled,
            hidden = _ref.hidden;
        return {
          name: name,
          value: value,
          disabled: disabled,
          hidden: hidden
        };
      });
    } else {
      return [{
        name: optionsWithPlaceholder.label,
        value: optionsWithPlaceholder.value
      }];
    }
  };

  var getMobileValue = function getMobileValue(value, newOptions, placeholder) {
    if (!value) {
      return {
        label: placeholder || null,
        value: null
      };
    }

    var label = Array.isArray(newOptions) ? newOptions.find(function (o) {
      return o.value === value;
    }).label : newOptions.label;
    return {
      label: label,
      value: value
    };
  };

  if (isMobile) {
    return /*#__PURE__*/_react.default.createElement(_select.FormMobileSelectStyled, {
      hideError: hideError,
      colorMark: colorMark,
      "data-test": dataTest,
      "data-test-id": dataTestId,
      role: "button",
      "aria-haspopup": "listbox",
      "aria-expanded": isOpen
    }, colorMark && /*#__PURE__*/_react.default.createElement(_select.ColorMarkStyled, null), /*#__PURE__*/_react.default.createElement(_triangleDown.default, {
      measure: 8,
      color: "gray800"
    }), /*#__PURE__*/_react.default.createElement(_reactUforms.Select, {
      multiple: isMulti,
      options: mobileOptions(options),
      onChange: function onChange(event, action) {
        if (_onChange) {
          _onChange(getMobileValue(JSON.parse(event.target.value)['v'], options, placeholder), action);
        }
      },
      id: id,
      name: name,
      required: required,
      disabled: disabled,
      size: size,
      onBlur: _onBlur,
      hideError: hideError
    }));
  }

  return /*#__PURE__*/_react.default.createElement(_reactUforms.CustomField, {
    name: name,
    hideError: hideError
  }, function (_ref2) {
    var getValue = _ref2.getValue,
        setValue = _ref2.setValue,
        getErrors = _ref2.getErrors,
        setTouched = _ref2.setTouched;
    return /*#__PURE__*/_react.default.createElement(_.Box, {
      "data-test": dataTest,
      "data-test-id": dataTestId,
      role: "button",
      "aria-haspopup": "listbox",
      "aria-expanded": isOpen
    }, /*#__PURE__*/_react.default.createElement(_select.FormSelectStyled, {
      components: {
        DropdownIndicator: _selectElements.DropdownIndicator,
        ClearIndicator: _selectElements.ClearIndicator,
        NoOptionsMessage: _selectElements.NoOptionsMessage,
        Option: Option,
        MultiValueRemove: _selectElements.MultiValueRemove,
        MultiValueContainer: _selectElements.MultiValueContainer
      },
      isDisabled: disabled,
      isCreatable: false,
      value: getValue() ? formatDefaultValues(getValue(), options) : null,
      hideSelectedOptions: false,
      menuPlacement: "auto",
      onChange: function onChange(newValue, action) {
        var value = undefined;

        if (newValue) {
          value = Array.isArray(newValue) ? newValue.map(function (item) {
            return item.value;
          }) : newValue.value;
        }

        setValue(value, function () {
          if (_onChange) {
            _onChange(newValue, action);
          }
        });
      },
      onBlur: function onBlur(event) {
        if (_onBlur) {
          _onBlur(event);
        }

        setTouched();
      },
      onMenuOpen: function onMenuOpen() {
        return setIsOpen(true);
      },
      onMenuClose: function onMenuClose() {
        return setIsOpen(false);
      },
      className: "react-select-container ".concat(location ? 'react-select-location' : ''),
      classNamePrefix: "react-select",
      instanceId: instanceId || name,
      error: Array.isArray(getErrors()) && getErrors().length > 0,
      id: id,
      ["menuPlacement"]: menuPlacement,
      name: name,
      required: required,
      options: options,
      isMulti: isMulti,
      placeholder: placeholder,
      isClearable: isClearable,
      colorMark: colorMark,
      isSearchable: isSearchable,
      onFocus: onFocus,
      onInputChange: onInputChange,
      showMultiOptionsCount: showMultiOptionsCount && isMulti
    }));
  });
};

exports.FormSelect = FormSelect;
FormSelect.defaultProps = {
  hideError: false,
  isMulti: false
};
FormSelect.displayName = 'FormSelect';